export default __webpack_public_path__ + "static/media/players_inventory_preview.13b655bf.png";